<div class="partner-list-header">
  <span class="partner-list-title">{{ 'partner.list.heading' | translate : { fgbdefault: 'My Partners' } }}</span>
  <span class="partner-list-count" *ngIf="{ approved: approvedPartners$ | async, pending: pendingPartners$ | async } as pt">
    {{ (pt.approved?.length || 0) + (pt.pending?.length || 0) }}
    {{ 'account.partners.of' | translate : { fgbdefault: 'of' } }}
    {{ partnerLimit }}
    {{ 'account.partners.used' | translate : { fgbdefault: 'used' } }}
  </span>
</div>

<ng-container
  *ngIf="{
    approvedPartners: approvedPartners$ | async,
    pendingPartners: pendingPartners$ | async
  } as pt"
>
  <div class="partner-list-placeholder" *ngIf="!pt.approvedPartners?.length && !pt.pendingPartners?.length">
    <img class="partner-list-placeholder-icon" [src]="'placeholders/partners.svg' | contentAssetImage" 
     alt="Partners" />
    <p class="partner-list-placeholder-text">
      {{ 'no.partner.placeholder' | translate : { fgbdefault: 'No Partners have been added. Add your first partner.' } }}
    </p>
  </div>

  <div class="partner-list-rows" *ngIf="pt.approvedPartners?.length || pt.pendingPartners?.length">
    <div *ngFor="let partner of pt.approvedPartners" class="partner-row">
      <div class="partner-row-identity">
        <div class="partner-avatar partner-avatar-active">{{ partner.FullName | initials }}</div>
        <div class="partner-row-text">
          <div class="partner-row-name">{{ partner.FullName }}</div>
          <div class="partner-row-email">{{ partner.Email }}</div>
        </div>
      </div>
      <div class="partner-row-meta">
        <span class="partner-status-chip partner-status-chip-active">{{
          'account.partners.status.partner' | translate : { fgbdefault: 'Partner' }
        }}</span>
        <button
          type="button"
          class="btn-outline-danger"
          confirmModal
          [confirmContent]="confirmContent"
          [confirmContext]="partner"
          (confirm)="delete(partner.RelationshipId)"
          aria-label="Remove partner"
        >
          {{ 'account.partners.remove' | translate : { fgbdefault: 'Remove' } }}
        </button>
      </div>
      <ng-template #confirmContent>
        <div class="delete-partner-modal">
          <div class="delete-partner-modal-header">
            {{ 'partner.delete.form.title' | translate : { fgbdefault: 'Delete Partner' } }}
          </div>
          <div class="delete-partner-modal-body">
            <p class="mb-0">{{ 'partner.list.modal.delete.message' | translate : { fgbdefault: 'Are you sure you want to delete this partner?' } }}</p>
            <p class="mb-0 text-ellipsis">
              <span class="fw-bold">{{ partner.FullName }}</span>
              <span>&nbsp;({{ partner.Email }})</span>
            </p>
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngFor="let partner of pt.pendingPartners" class="partner-row partner-row-pending">
      <div class="partner-row-identity">
        <div class="partner-avatar partner-avatar-pending">{{ partner.FullName | initials }}</div>
        <div class="partner-row-text">
          <div class="partner-row-name">{{ partner.FullName }}</div>
          <div class="partner-row-email">{{ partner.Email }}</div>
        </div>
      </div>
      <div class="partner-row-meta">
        <span class="partner-status-chip partner-status-chip-pending">{{
          'account.partners.status.pending' | translate : { fgbdefault: 'Invite pending' }
        }}</span>
        <button
          type="button"
          class="btn-outline-danger"
          confirmModal
          [confirmContent]="confirmContent"
          (confirm)="deletePending(partner.TicketKey)"
          aria-label="Cancel invite"
        >
          {{ 'account.partners.cancel' | translate : { fgbdefault: 'Cancel' } }}
        </button>
      </div>
      <ng-template #confirmContent>
        <div class="delete-partner-modal">
          <div class="delete-partner-modal-header">
            {{ 'partner.delete.form.title' | translate : { fgbdefault: 'Delete Partner' } }}
          </div>
          <div class="delete-partner-modal-body">
            <p class="mb-0">{{ 'partner.list.modal.delete.message' | translate : { fgbdefault: 'Are you sure you want to delete this partner?' } }}</p>
            <p class="mb-0 text-ellipsis">
              <span class="fw-bold">{{ partner.FullName }}</span>
              <span>&nbsp;({{ partner.Email }})</span>
            </p>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
